import { SiteFooter } from "@/components/SiteFooter";
import { SiteHeader } from "@/components/SiteHeader";

export const InnerPageLayout = ({ eyebrow, title, intro, children, testId }) => (
  <div className="explordio-page inner-page" data-testid={testId}>
    <SiteHeader />
    <main className="inner-main">
      <header className="inner-hero" data-testid={`${testId}-hero`}>
        <p className="inner-eyebrow" data-testid={`${testId}-eyebrow`}>{eyebrow}</p>
        <h1 data-testid={`${testId}-title`}>{title}</h1>
        <p data-testid={`${testId}-intro`}>{intro}</p>
      </header>
      {children}
    </main>
    <SiteFooter />
  </div>
);